import { ArrowRight, Mic, Briefcase, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

const heroImage = "https://customer-assets.emergentagent.com/job_1e4866aa-1b76-485b-9ba8-54acbae14c92/artifacts/0lvrpq7z_IMG_5316.jpeg";

const Hero = () => {
  return (
    <section className="min-h-screen pt-20 bg-gradient-to-br from-background via-muted/20 to-background relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-40 right-10 w-72 h-72 bg-primary/5 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-gold/5 rounded-full blur-3xl" />
      
      <div className="container mx-auto px-6 py-16 lg:py-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
              <Heart className="w-4 h-4" />
              <span className="text-sm font-medium">Entrepreneur • Speaker • Minister</span>
            </div>

            <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6">
              Build Your Life
              <span className="block text-primary">With Purpose</span>
            </h1>

            <p className="text-xl text-muted-foreground leading-relaxed mb-8 max-w-lg">
              I help entrepreneurs and individuals transform their businesses, finances, and lives 
              through strategic guidance, celebration, and faith. Let's unlock your potential together.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 mb-12">
              <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8">
                <a href="#solutions" className="flex items-center gap-2">
                  Work With Me
                  <ArrowRight className="w-4 h-4" />
                </a>
              </Button>
              <Button asChild variant="outline" size="lg" className="rounded-full px-8 border-2">
                <a href="#speaking" className="flex items-center gap-2">
                  <Mic className="w-4 h-4" />
                  Book Speaking
                </a>
              </Button>
            </div>

            {/* Quick Stats */}
            <div className="flex flex-wrap gap-8">
              <div>
                <p className="text-3xl font-bold text-foreground">500+</p>
                <p className="text-sm text-muted-foreground">Businesses Helped</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-foreground">Navy</p>
                <p className="text-sm text-muted-foreground">Veteran</p>
              </div>
              <div>
                <p className="text-3xl font-bold text-foreground">3</p>
                <p className="text-sm text-muted-foreground">Thriving Businesses</p>
              </div>
            </div>
          </div>

          {/* Image */}
          <div className="order-1 lg:order-2 flex justify-center lg:justify-end">
            <div className="relative">
              {/* Background shape */}
              <div className="absolute -inset-4 bg-gradient-to-br from-primary/20 via-gold/10 to-transparent rounded-3xl blur-2xl" />
              
              {/* Image container */}
              <div className="relative rounded-3xl overflow-hidden shadow-2xl max-w-md">
                <img 
                  src={heroImage} 
                  alt="LaVista Smith" 
                  className="w-full h-auto object-cover"
                />
                {/* Overlay gradient */}
                <div className="absolute inset-0 bg-gradient-to-t from-accent/40 via-transparent to-transparent" />
              </div>

              {/* Floating badge */}
              <div className="absolute -bottom-4 -left-4 bg-card p-4 rounded-xl shadow-lg border border-border">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-gold/20 rounded-lg">
                    <Briefcase className="w-5 h-5 text-gold" />
                  </div>
                  <div>
                    <p className="font-bold text-foreground">Veteran Owned</p>
                    <p className="text-xs text-muted-foreground">NNA Certified</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
